import type { GeoPoint } from '@/types'

/**
 * Single source of truth for the district list-of-values used across the app
 * (forms, filters, the map). The editable runtime list lives in the districts
 * store (`@/store/districts`), seeded from DEFAULT_DISTRICTS below and managed
 * in Settings → Reference Data. DISTRICT_CENTERS gives a map coordinate per
 * district (used by the map to fly-to / seed the radius centre).
 *
 * Covers all 23 districts of West Bengal (centres ~ district HQ towns).
 */
export const DISTRICT_CENTERS: Record<string, GeoPoint> = {
  Alipurduar: { lat: 26.492, lng: 89.527 },
  Bankura: { lat: 23.2324, lng: 87.0753 },
  Birbhum: { lat: 23.9135, lng: 87.529 },
  'Cooch Behar': { lat: 26.3242, lng: 89.4482 },
  'Dakshin Dinajpur': { lat: 25.222, lng: 88.766 },
  Darjeeling: { lat: 27.036, lng: 88.2627 },
  Hooghly: { lat: 22.9089, lng: 88.396 },
  Howrah: { lat: 22.5958, lng: 88.2636 },
  Jalpaiguri: { lat: 26.5215, lng: 88.7196 },
  Jhargram: { lat: 22.4535, lng: 86.9975 },
  Kalimpong: { lat: 27.06, lng: 88.47 },
  Kolkata: { lat: 22.5726, lng: 88.3639 },
  Malda: { lat: 25.0119, lng: 88.1433 },
  Murshidabad: { lat: 24.105, lng: 88.251 },
  Nadia: { lat: 23.4009, lng: 88.5017 },
  'North 24 Parganas': { lat: 22.72, lng: 88.48 },
  'Paschim Bardhaman': { lat: 23.68, lng: 86.99 },
  'Paschim Medinipur': { lat: 22.4257, lng: 87.3199 },
  'Purba Bardhaman': { lat: 23.2324, lng: 87.8615 },
  'Purba Medinipur': { lat: 22.298, lng: 87.92 },
  Purulia: { lat: 23.332, lng: 86.365 },
  'South 24 Parganas': { lat: 22.16, lng: 88.4 },
  'Uttar Dinajpur': { lat: 25.6167, lng: 88.1167 },
}

export const DEFAULT_DISTRICTS = Object.keys(DISTRICT_CENTERS)
